(function($) {


  var frontImageSlider = $('#front-image-slider'),
      frontTextSlider = $('#front-text-slider');


  $(frontImageSlider).slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '#front-text-slider',
    lazyLoad: 'ondemand',

  });

  $(frontTextSlider).slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '60px',
    fade: true,
    cssEase: 'linear',
    asNavFor: '#front-image-slider',
    swipe: false

  });




})( jQuery );
